import React from 'react';

const SettingsMenu = ({ 
  numStories, setNumStories,
  staleAfterMins, setStaleAfterMins,
  onClose }) => {

  const posIntChanger = (storageKey, setter) => (event) => {   
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value) && value > 0) {
      setter(value);
    }
    localStorage.setItem(storageKey, value)
  };


  return (
    <div className="settings-menu flex flex-col gap-4">
      <span className='text-[0.6em]'> Offline HackerNews - <a className="text-blue-400 " href="https://github.com/ltolias">Leonidas Tolias</a></span>
      <div className='flex items-center justify-end gap-4'>
        <span className='text-[1em]'>
          Stories per page:  
        </span>
        <input
          type="number"
          value={numStories}
          onChange={posIntChanger('numStories', setNumStories)}
        />
      </div>
      <div className='flex items-center justify-content gap-4'>
        <span className='text-[1em]'>
          Stories stale after (mins):  
        </span>
        <input
          type="number"
          value={staleAfterMins}
          onChange={posIntChanger('staleAfterMins', setStaleAfterMins)}
        />
      </div>
      <div className='flex justify-between'>
        <button className='justify-left bg-[#666] px-4 py-2 rounded-[10px]' onClick={() => window.location.reload()}>Refresh</button>
        <button className='justify-right bg-[#666] px-4 py-2 rounded-[10px]' onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default SettingsMenu;